import { SvgIcon, clsx } from "@gemlightbox/core-kit";
import { observer } from "mobx-react-lite";
import React from "react";

import { ReactComponent as HintSVG } from "src/external-ts/assets/images/hint-icon.svg";
import styles from "./lifetime-offer.module.css";
import { useStores } from "src/hooks";

export interface LifetimeOfferProps {
  className?: string;
  extraCount: number;
}

export const LifetimeOffer: React.FC<LifetimeOfferProps> = observer(
  ({ className = "", extraCount }: LifetimeOfferProps) => {
    const { localeStore, subscriptionsStore } = useStores();
    const currentExtraCount = extraCount - subscriptionsStore.subGbAddonsAmount;
    const extraPriceToday =
      currentExtraCount * subscriptionsStore.subaccountAddonPrices.yearlyPrice;
    const extraPriceYr = extraCount * subscriptionsStore.subaccountAddonPrices.yearlyPrice;
    const yearlyText = `US$${extraPriceYr}/yr`;

    return (
      <>
        <div className={clsx(styles.lifetimeOffer, className)}>
          {currentExtraCount === 0 ? (
            <div className={styles.typography}>
              <SvgIcon icon={HintSVG} size={16} />
              <span>
                {localeStore.t('settings.subscriptions.components.content["lifetime-offer"].title')}
              </span>
            </div>
          ) : (
            <>
              <div className={styles.yearlyWrapper}>
                <span className={styles.yearlyText}>Yearly</span>
                <span className={styles.yearlyPrice}>{yearlyText}</span>
              </div>
              {currentExtraCount >= 0 && (
                <span className={styles.expandAgain}>
                  {localeStore.t(
                    'settings.subscriptions.components.content["lifetime-offer"]["today-charge"].first',
                  )}{" "}
                  ${subscriptionsStore.formattedBillingInfo?.current_amount_due ?? "--"}{" "}
                  {localeStore.t(
                    'settings.subscriptions.components.content["lifetime-offer"]["today-charge"].today',
                  )}{" "}
                  ({localeStore.t("settings.subscriptions.components.content.balance")}).
                </span>
              )}
            </>
          )}
        </div>
      </>
    );
  },
);
